

import Component from './component';
import createComponentFactory from '../createComponent';
import { TweenMax, Expo } from 'gsap/umd/TweenMax';
import 'gsap/umd/ScrollToPlugin';


class ScrollAnchor extends Component {

  constructor(element, context, options) {
    super(element, context, options);


    this._handleAnchorClick = this._handleAnchorClick.bind(this);
  }

  _bindEvents() {
    this.element.addEventListener('click', this._handleAnchorClick);
  }

  _unbindEvents() {
    this.element.removeEventListener('click', this._handleAnchorClick);
  }

  _handleAnchorClick(evt) {

    const target = evt.currentTarget;
    const href = target.getAttribute('href');

    if(href.charAt(0) !== '#' || target.classList.contains('no-scroll')) {
      return;
    }

    const dest = document.getElementById(href.substring(1));

    TweenMax.to(window, .75, {
      scrollTo: { y: dest },
      ease: Expo.easeInOut
    });

    evt.preventDefault();
  }

  didRegisterComponent() {
    this._bindEvents();
  }

  didUnregisterComponent() {
    this._unbindEvents();
  }
}

export default createComponentFactory(ScrollAnchor);



// WEBPACK FOOTER //
// ./src/js/app/component/scrollAnchor.js